import { useState } from 'react';
import AjaxUtil from '../../common/js/AjaxUtil.ts';

export default function LoadingScreenViewModel() {

	const [message, setMessage] = useState("Loading...");

	const loadData = (setCompanies, setConfigs, finished) => {
		Promise.all([
			fetch("api/v1/getCompanyList").then(res => res.json()),
			fetch("api/v1/getConfigNames").then(res => res.json()),
		]).then(results => {
    		
			if (results[0].success && results[0].data) {
				setCompanies(results[0].data)
			}


			if (results[1].success && results[1].data) {
				setConfigs(results[1].data);
			}

			finished();

		});
	};

	

	const loadSession = (setCompanies, setConfigs, setApiKey, finished) => {
		var url = "api/v1/getSession";
		var success = (result) => {
			if (result.success){
				setApiKey(result.apiKey);
				loadData(setCompanies, setConfigs, finished);
			}else if (result.loginUrl){
				window.location.href = result.loginUrl;
			}else{
				setMessage("Failed to retrieve session");
			}
		};
		AjaxUtil.fetchPost({ url, success });
	};


	return {
		message, setMessage,
		loadSession,

	};

}